import script from "./FormParceriaInterna.vue?vue&type=script&setup=true&lang=js"
export * from "./FormParceriaInterna.vue?vue&type=script&setup=true&lang=js"

import "./FormParceriaInterna.vue?vue&type=style&index=0&id=16a5fd16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a5fd16"]])

export default __exports__